import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Input, Modal, Row, Table, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import { KeyResultSymbol, ObjectiveSymbol } from 'app/config/constants';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import ModalRejectComponent from 'app/shared/component/modal/reject';
import * as _ from 'lodash';
import { checkPermission, checkPermissionAdjustment, completeProcess, completeProcessAdjustment, getCurrentProcess, getCurrentProcessAdjustment, getEntitiesApprove, getEntitiesApproveAdjustment, getOtherComment, getOtherCommentAdjustment, rejectProcess, rejectProcessAdjustment, resetApprovalEntity, saveDraft, saveDraftAdjustment, submitApprove } from './category-approve.reducer';
import { columnsApprove } from './config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OtherCommentComponent from './other-comment';
import { FuncTypes, funcTypeToString } from 'app/shared/model/enum/func-type.enum';
import { setFilterOrgCheckIn } from 'app/entities/filters/filters.reducer';
import { ReportKr as ReportYear } from 'app/entities/kr/form/report/year/reportKr';
import AdjustObjectiveUpdate from 'app/entities/objective/form/objective-update-adjustment';
import KRUpdate from 'app/entities/kr/form/kr-update';
import CopyKR from 'app/entities/kr/form/copy/copy-kr';
import { log } from 'react-jhipster';
import CopyKRVer from 'app/entities/kr/form/copy/copy-kr-ver';
import { getActiveYearPlanningWindow } from 'app/entities/annual-plan-window/annual-plan-window.reducer';

type IApproveObjectiveKRProps = {
    isOpen: boolean;
    onClose: (isReload?: boolean) => void;
    documentId: string;
    accountTableId: string;
    accountableName: string;
    planPeriodId: string;
    selectedPeriod: number;
};

const { Search } = Input;

export const ApproveObjectiveKRComponent = ({ isOpen, onClose, documentId, accountTableId, accountableName, planPeriodId, selectedPeriod }: IApproveObjectiveKRProps) => {

    const dispatch = useAppDispatch();
    const treeData = useAppSelector(state => state.categoryApprove.entityApproves);
    const loading = useAppSelector(state => state.categoryApprove.loading);
    const updating = useAppSelector(state => state.categoryApprove.updating);
    const account = useAppSelector(state => state.authentication.account);
    const otherComment = useAppSelector(state => state.categoryApprove.otherComment);
    const currentStatusProcessApprove = useAppSelector(state => state.categoryApprove.entity);
    const planningYear = useAppSelector(state => {
        const entity = state.yearPlanningWindow.entity;
        return entity?.year ?? (entity?.planYear != null ? Number(entity.planYear) : undefined);
    });

    const [KRComments, setKRComments] = useState([])
    const [isOpenModalConfirmApprove, setOpenModalConfirmApprove] = useState(false);
    const [isOpenModalConfirmComplete, setOpenModalConfirmComplete] = useState(false);
    const [isOpenModalReject, setOpenModalReject] = useState(false);
    const [isUpdateSuccess, setUpdateSuccess] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [isLoadingComment, setLoadingComment] = useState(false);
    const [isOpenModalOtherComment, setOpenModalOtherComment] = useState(false);
    const [isOpenModalReportKr, setOpenModalReportKr] = useState(false);
    const [krBaseSelected, setKrBaseSelected] = useState(null);
    const [objSelected, setObjSelected] = useState(null);
    const [isOpenAdjustmentModel, setOpenAdjustmentModel] = useState(false);
    const [hasPermission, setPermission] = useState(null);

    useEffect(() => {
        dispatch(getActiveYearPlanningWindow());
        handleGetTreeOrg();
        handleGetCurrentProcess();
        handleCheckPermission();
    }, [])

    useEffect(() => {
        if (isUpdateSuccess)
            handleClose();
    }, [isUpdateSuccess])

    useEffect(() => {
        if (treeData.length > 0) {
            const allRowKeys = getAllRowKeys(treeData);
            setExpandedRowKeys(allRowKeys);
            setKRComments(getAllChildren(treeData).map(x => {
                return {
                    itemId: x?.itemId,
                    agree: x?.isAgree,
                    comment: x?.feedbackContent,
                }
            }))
        }
    }, [treeData])

    const columnConfig = [...columnsApprove, {
        title: `${treeData[0]?.processingLevelName} - ${treeData[0]?.processingPerformerName}`,
        width: 300,
        children: [
            {
                title: 'Đồng ý',
                key: 'agree',
                width: 80,
                align: 'center',
                render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) && <Checkbox disabled={!record?.isEdit} defaultChecked={record?.isAgree} onChange={(e) => { handleChangeCheckBox(record.itemId, e.target.checked) }} />
            },
            {
                title: 'Ý kiến',
                key: 'comment',
                width: 250,
                align: 'center',
                render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) && <Input disabled={!record?.isEdit} defaultValue={record?.feedbackContent} onChange={(e) => { handleChangeInput(record.itemId, e.target.value) }} />
            },
            {
                key: 'action',
                width: 60,
                align: 'center',
                render: (record) => _.startsWith(record.itemCode, KeyResultSymbol) &&
                    <Tooltip title="Xem ý kiến khác">
                        <FontAwesomeIcon
                            onClick={(e) => {
                                handleGetOtherComments(e, record.itemId);
                            }}
                            icon="eye"
                            color='blue'
                        />
                    </Tooltip>
            }
        ]
    }];

    const getAllChildren = (nodes) => {
        let children = [];
        nodes.forEach(node => {
            children = children.concat(node.children); // Add the current node
        });
        return children;
    };

    const getAllRowKeys = (item) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.itemId}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children));
            }

            return keys;
        }, []);
    };


    const handleGetTreeOrg = () => {
        if (selectedPeriod === 3) {
            dispatch(getEntitiesApproveAdjustment({ ownerId: account?.id, accountTableId, planPeriodId }))
        } else {
            dispatch(getEntitiesApprove({ ownerId: account?.id, accountTableId, planPeriodId }))
        }
    }

    const handleExport = (values) => {
        console.log(values);
    }

    const handleFreeTextSearchQuery = query => {
        // dispatch(setListFilterApprovalLevel({ ...filters, searchText: query }))
    };

    const handleClose = () => {
        dispatch(resetApprovalEntity())
        onClose(isUpdateSuccess);
    };

    const handleChangeCheckBox = (recordId, agree) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === recordId) {
                    return { ...item, agree };
                }
                return item;
            });
        });
    }

    const handleChangeInput = (recordId, comment) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === recordId) {
                    return { ...item, comment };
                }
                return item;
            });
        });
    }

    const mapData = () => {

        if (selectedPeriod === 3) {
            return {
                documentId,
                ownerId: accountTableId,
                userId: account?.id,
                year: planningYear,
                approveLevelId: treeData.length > 0 ? treeData[0]?.processingLevelId : undefined,
                checkinFeedbackItems: KRComments.map(x => {
                    return {
                        itemId: x.itemId,
                        isAgree: x.agree,
                        feedbackContent: x.comment
                    };
                })
            };
        }

        return {
            documentId,
            ownerId: accountTableId,
            userId: account?.id,
            year: planningYear,
            approveLevelId: treeData.length > 0 ? treeData[0]?.processingLevelId : undefined,
            approveFeedbackItems: KRComments.map(x => {
                return {
                    itemId: x.itemId,
                    isAgree: x.agree,
                    feedbackContent: x.comment
                };
            })
        };
    }
    const handleSaveDraft = () => {
        const payload = mapData()
        if (selectedPeriod === 3) {
            dispatch(saveDraftAdjustment(payload))
        } else {
            dispatch(saveDraft(payload))
        }
    }

    const handleOpenModalConfirmApprove = () => {
        setOpenModalConfirmApprove(true);
    }

    const handleConfirmApprove = () => {
        setOpenModalConfirmApprove(true);
        handleApproveItemSelected()
    }

    const handleApproveItemSelected = () => {
        const payload = mapData()
        if (selectedPeriod === 3) {
            dispatch(completeProcessAdjustment(payload)).then((res) => {
                if (res && res.payload)
                    setUpdateSuccess(true)
            })
        } else {
            dispatch(completeProcess(payload)).then((res) => {
                if (res && res.payload)
                    setUpdateSuccess(true)
            })
        }
    }

    const handleOpenModalConfirmComplete = () => {
        setOpenModalConfirmComplete(true);
    }

    const handleConfirmComplete = () => {
        const payload = mapData()
        setOpenModalConfirmComplete(false);
        if (selectedPeriod === 3) {
            dispatch(completeProcessAdjustment(payload)).then((res) => {
                if (res && res.payload)
                    setUpdateSuccess(true)
            })
        } else {
            dispatch(completeProcess(payload)).then((res) => {
                if (res && res.payload)
                    setUpdateSuccess(true)
            })
        }
    }

    const handleOpenModalReject = () => {
        setOpenModalReject(true);
    }

    const handleReject = (reason: string) => {
        const payload = { ...mapData(), reason }
        setOpenModalReject(false);
        if (selectedPeriod === 3) {
            dispatch(rejectProcessAdjustment(payload)).then((res) => {
                if (res && res.payload)
                    setUpdateSuccess(true)
            })
        } else {
            dispatch(rejectProcess(payload)).then((res) => {
                if (res && res.payload)
                    setUpdateSuccess(true)
            })
        }
    }

    const handleOpenModalOtherComment = () => {
        setOpenModalOtherComment(true);
    }

    const handleCloseModalOtherGeneralComment = () => {
        setOpenModalOtherComment(false);
    }

    const handleGetOtherComments = (e, value) => {
        e.stopPropagation();
        setLoadingComment(true);
        handleOpenModalOtherComment()
        if (selectedPeriod === 3) {
            dispatch(getOtherCommentAdjustment({ itemId: value, ownerId: accountTableId, planPeriodId })).finally(() => { setLoadingComment(false) });
        } else {
            dispatch(getOtherComment({ itemId: value, ownerId: accountTableId, planPeriodId })).finally(() => { setLoadingComment(false) });
        }
    }

    const handleFinish = () => {
        handleOpenModalConfirmApprove()
    }

    const handleGetCurrentProcess = () => {
        if (selectedPeriod === 3) {
            dispatch(getCurrentProcessAdjustment({ ownerId: accountTableId, userId: account?.id, planPeriodId }));
        } else {
            dispatch(getCurrentProcess({ ownerId: accountTableId, userId: account?.id, planPeriodId }));
        }
    }

    const handleRowClick = (event, record) => {
        event.preventDefault();
        if (record?.itemId && hasPermission !== null) {
            if (_.startsWith(record?.itemCode, KeyResultSymbol))
                handleOpenModalKr(record)
            else
                handleOpenModalAdjustmentObjective(record)
        }
    };

    const handleOpenModalKr = (dataKr = null) => {
        if (dataKr) {
            setKrBaseSelected({
                id: dataKr.itemId,
                planPeriodId: dataKr?.planPeriodId,
                objectiveId: dataKr?.objectiveId,
                krType: dataKr?.krType,
                planPeriodType: dataKr?.planPeriodType
            })
        }
        setOpenModalReportKr(true);
    };

    const handleCloseModalKr = reload => {
        setOpenModalReportKr(false);
        setKrBaseSelected(null)
        if (reload)
            handleGetTreeOrg();
    };

    const handleOpenModalAdjustmentObjective = (item) => {
        setObjSelected({
            id: item.itemId
        })
        setOpenAdjustmentModel(true);
    };

    const handleCloseModalAdjustmentObjective = reload => {
        setOpenAdjustmentModel(false);
        setObjSelected(null)
        if (reload)
            handleGetTreeOrg();
    };

    const handleCheckPermission = () => {
        if (selectedPeriod === 3) {
            dispatch(checkPermissionAdjustment({ ownerId: accountTableId, userId: account?.id, planPeriodId })).then((res) => {
                if (res && res.payload) {
                    const response = (res.payload as any).data
                    setPermission(response.permission);
                }
            });
        } else {
            dispatch(checkPermission({ ownerId: accountTableId, userId: account?.id, planPeriodId })).then((res) => {
                if (res && res.payload) {
                    const response = (res.payload as any).data
                    setPermission(response.permission);
                }
            });
        }
    }

    return (
        <Modal open={isOpen} maskClosable={false} confirmLoading={updating} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>{selectedPeriod === 3 ? (planningYear ? `Phê duyệt mục tiêu năm ${planningYear} điều chỉnh` : 'Phê duyệt mục tiêu năm điều chỉnh') : 'Phê duyệt mục tiêu'} - {accountableName}</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={8}>
                        <Row className='w-100'>
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={13}>
                        <Row className='w-100 justify-content-end gap-2'>

                            <Button size="large" onClick={handleSaveDraft} disabled={updating || !planningYear} className="green">
                                Lưu nháp
                            </Button>
                            {(currentStatusProcessApprove.functionKey === FuncTypes.Check || currentStatusProcessApprove.functionKey === FuncTypes.Appraisal) &&
                                <Button size="large" onClick={handleOpenModalConfirmComplete} disabled={updating || !planningYear} className="green">
                                    {`Hoàn thành ${funcTypeToString(currentStatusProcessApprove.functionKey)}`}
                                </Button>
                            }
                            {currentStatusProcessApprove.functionKey === FuncTypes.Approve &&
                                <Button size="large" onClick={handleFinish} disabled={updating || !planningYear} className="green">
                                    Phê duyệt
                                </Button>
                            }
                            {currentStatusProcessApprove.functionKey !== FuncTypes.Appraisal &&
                                <Button size="large" onClick={handleOpenModalReject} disabled={updating || !planningYear} className="warning">
                                    Yêu cầu sửa lại
                                </Button>
                            }
                        </Row>
                    </Col>
                </div>
                <Table tableLayout='fixed' scroll={{ y: '60vh' }}
                    expandable={{
                        expandedRowKeys,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }}
                    rowClassName={(record, index) =>
                        _.startsWith(record.itemCode, ObjectiveSymbol) ? "fw-bold" : "" // Định nghĩa lớp CSS cho dòng lẻ
                    }
                    onRow={(record) => ({
                        onClick(event) {

                            const target = event.target as HTMLElement;
                            // Lấy danh sách tất cả các ô (td) trong hàng được nhấp
                            const cells = Array.from(event.currentTarget.querySelectorAll('td'));

                            // Xác định index của ô được nhấp
                            const clickedTd = target.closest('td'); // Tìm td gần nhất
                            if (!clickedTd) return; // Tránh lỗi nếu không tìm thấy td

                            const clickedIndex = cells.indexOf(clickedTd);

                            // Danh sách index của các cột cần loại trừ
                            const excludedIndexes = [7, 8, 9];

                            if (!excludedIndexes.includes(clickedIndex)) {
                                handleRowClick(event, record);
                            }
                        },
                    })}
                    loading={loading || updating} bordered dataSource={treeData.map(x => ({
                        ...x,
                        key: x.itemId,
                        children: x.children?.map(y => ({ ...y, key: y.itemId }))
                    }))} pagination={false} columns={columnConfig} />
            </div>
            {isOpenModalReportKr && selectedPeriod === 3 ?
                <CopyKRVer
                    isOpen={isOpenModalReportKr}
                    isReadOnly={!hasPermission}
                    onClose={handleCloseModalKr}
                    krTypeRequest={krBaseSelected?.krType}
                    planPeriodType={krBaseSelected?.planPeriodType}
                    planPeriodIdSelected={krBaseSelected?.planPeriodId}
                    idKrBaseSelected={krBaseSelected?.id}
                    selectedPeriod={selectedPeriod}
                    idObjective={krBaseSelected?.objectiveId} isEdit={true} />
                : <CopyKR
                    isOpen={isOpenModalReportKr}
                    isReadOnly={!hasPermission}
                    onClose={handleCloseModalKr}
                    krTypeRequest={krBaseSelected?.krType}
                    planPeriodType={krBaseSelected?.planPeriodType}
                    planPeriodIdSelected={krBaseSelected?.planPeriodId}
                    idKrBaseSelected={krBaseSelected?.id}
                    selectedPeriod={selectedPeriod}
                    idObjective={krBaseSelected?.objectiveId} isEdit={true} />
            }
            {isOpenAdjustmentModel && (
                <AdjustObjectiveUpdate selectedPeriod={selectedPeriod} isOpen={isOpenAdjustmentModel} isReadOnly={!hasPermission} onClose={handleCloseModalAdjustmentObjective} id={objSelected?.id} />
            )}
            <ModalConfirmComponent
                visible={isOpenModalConfirmApprove}
                onCancel={() => {
                    setOpenModalConfirmApprove(false);
                }}
                onConfirm={handleConfirmApprove}
                isLoading={updating}
                title={`Bạn có chắc chắn muốn phê duyệt ?`}
            />
            <ModalConfirmComponent
                visible={isOpenModalConfirmComplete}
                onCancel={() => {
                    setOpenModalConfirmComplete(false);
                }}
                onConfirm={handleConfirmComplete}
                isLoading={updating}
                title={`Bạn đã hoàn thành kiểm tra dữ liệu ?`}
            />
            <ModalRejectComponent
                visible={isOpenModalReject}
                onCancel={() => {
                    setOpenModalReject(false);
                }}
                onReject={handleReject}
                isLoading={updating}
                title={`Yêu cầu sửa lại ?`} />
            {isOpenModalOtherComment &&
                <OtherCommentComponent
                    isLoading={isLoadingComment}
                    data={otherComment}
                    isOpen={isOpenModalOtherComment}
                    onClose={handleCloseModalOtherGeneralComment} />}
        </Modal>
    );
};

export default ApproveObjectiveKRComponent;
